import { render, staticRenderFns } from "./MediaBlock.vue?vue&type=template&id=385760de&scoped=true&"
import script from "./MediaBlock.vue?vue&type=script&lang=js&"
export * from "./MediaBlock.vue?vue&type=script&lang=js&"
import style0 from "./MediaBlock.vue?vue&type=style&index=0&id=385760de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385760de",
  null
  
)

export default component.exports